export const URL = "wss://files.ysafe.io:5577";
export const WOPI_URL = "http://wopi:5000";
export const COLLABORA_URL = "http://192.168.1.24:9980";
export const COLLABORA_STATE = false;